module.exports = __webpack_public_path__ + "img/users.b0e9fa3e.svg";